export default "__VITE_PUBLIC_ASSET__deef40fd__"